import React, { useEffect, useState } from "react";
import useDataSession from "../../customeHooks/useDataSession";
import useCoreAgora from "../../../../general/customHooks/coreAgora";
import { classNames } from "../../../../general/functions/propsComponent";
import VideoPlayer from "../../../../general/components/VideoUser/VideoPlayer";
import { checkVoulumeLevel } from "../../../../general/functions/agoraCustomeFunctions";
import { StartRecording } from "../../actions/recordingActions";
import { useDispatch, useSelector } from "react-redux";
import AssessorControls from "../molekuls/AssessorControls";
import AnswerListFromAssessee from "../molekuls/AnswerListFromAssessee";
import GuideAssessor from "../molekuls/GuideAssessor";
import HeaderOnSesssion from "../molekuls/HeaderOnSesssion";
import useRoomAgora from "../../customeHooks/useRoomAgora";
export default function CaAssessorView() {
  const { selfUid, session, listUser, dataSession } = useDataSession();
  console.log("useDataSession", selfUid, session, dataSession, listUser);
  const [listUserData, setListUserData] = useState([]);
  const [showGuide, setShowGuide] = useState(false);
  const [showListAnswer, setShowListAnswer] = useState(false);
  const {
    usersJoin,
    usersVolume,
    isConnect,
    isSelfTracksReady,
    selfTracks,
    isMuteTrackSelf,
    isShareScreen,
    setJoin,
    setMuteSelfTracks,
    setSchareScreen,
    setShareScreenUid,
    errorInfo,
    stats,
  } = useCoreAgora({
    uid: parseInt(selfUid),
    channelName: session,
  });
  const { handleLeaveAlone } = useRoomAgora({ setJoin });

  useEffect(() => {
    // modal error
    console.log("errorInfo", errorInfo);
  }, [errorInfo]);
  console.log("stats", stats);
  useEffect(() => {
    setJoin(true);
  }, []);

  useEffect(() => {
    let tmp = listUser?.map((x) => {
      let dTmp = usersJoin.find((y) => y.uid == x.uId);

      if (dTmp != undefined) {
        x.agora = dTmp;
      } else {
        x.agora = null;
      }
      return x;
    });
    let uidShareScreen = tmp?.find(
      (y) => y.agora == null && y.type == "SHARESCREEN"
    );
    setShareScreenUid(
      uidShareScreen?.uId != undefined ? uidShareScreen?.uId : null
    );
    console.log("tmp", tmp);
    setListUserData(tmp);
  }, [usersJoin, listUser]);

  const dispatch = useDispatch();
  const store = useSelector((state) => state.smvm_recording);
  useEffect(() => {
    // console.log("Start Record Effect");
    if (isConnect == true && recordingIsAvailable == false) {
      // console.log("Send Start Record Effect");
      dispatch(StartRecording(dataSession?.sessionInfo?.projectId));
    }
    if (isConnect) {
      // setMuteSelfTracks("audio", false);
      setMuteSelfTracks("video", false);
    }
  }, [isConnect]);

  let screenShareAvailable =
    listUserData?.find((x) => x.type == "SHARESCREEN")?.agora?.agoraDetail !=
    null;
  let recordingIsAvailable =
    listUserData?.find((x) => x.type == "RECORDING")?.agora != null;
  let positionVideoList =
    listUserData?.filter((x) => x.type != "RECORDING" && x.agora != null)
      .length >= 4;
  console.log(
    "recordingIsAvailable",
    recordingIsAvailable,
    listUserData?.find((x) => x.type == "RECORDING")?.agora,
    listUserData?.find((x) => x.type == "RECORDING"),
    screenShareAvailable
  );
  return (
    <>
      <div
        className=" h-full flex w-full overflow-hidden"
        style={{ height: "92vh", maxWidth: "100vw", minHeight: "720px" }}
      >
        <div className={classNames("w-full h-full  mx-auto  ")}>
          <HeaderOnSesssion
            title={"CASE ANALYSIS | " + dataSession.sessionInfo?.sessionTitle}
            sub={
              "Assessor View, " +
              (recordingIsAvailable ? "Record" : "Not Record")
            }
          />
          {/* <div className="flex">
            <div className="flex justify-center items-center pl-2">
              <LogoPColor className="h-10" />
            </div>
            <div className="text-white  p-2 flex flex-col justify-start items-start">
              <h1 className="text-lg font-medium">
                INTERVIEW | {dataSession.sessionInfo?.sessionTitle}
              </h1>
              <p
                onClick={() => {
                  dispatch(StartRecording(dataSession?.sessionInfo?.projectId));
                }}
              >
                Assessor View, {recordingIsAvailable ? "Record" : "Not Record"}{" "}
                | 12:00
              </p>
            </div>
          </div> */}
          <div
            className=" flex justify-center items-center pt-4  w-full"
            style={{
              height: screenShareAvailable ? "75%" : "65%",
            }}
          >
            <div
              className="aspect-video  flex  items-center justify-center "
              style={{ width: "100%", maxHeight: "100%" }}
            >
              {selfTracks && isConnect && (
                <VideoMain
                  userAssessee={listUserData.find((x) => x.type == "ASSESSEE")}
                  shareScreen={listUserData.find(
                    (x) => x.type == "SHARESCREEN"
                  )}
                  usersVolume={usersVolume}
                />
              )}
            </div>
          </div>

          <div
            className={classNames(
              " flex gap-2 mt-2  overflow-auto p-2 ",
              positionVideoList ? "" : "justify-center"
            )}
            style={{
              height: screenShareAvailable ? "15%" : "25%",
              width: "100%",
            }}
          >
            {selfTracks && isConnect && (
              <VideoList
                users={listUserData}
                userSelf={{ ...dataSession?.user, isMuteTrackSelf }}
                usersVolume={usersVolume}
                tracks={selfTracks}
              />
            )}
          </div>
        </div>
        <div
          className={classNames(
            "sticky  top-0 max-w-sm  right-0  min-h-screen   bg-gray-100 transition-all duration-100  ease-out",
            showListAnswer
              ? " -translate-x-0 w-full "
              : "translate-x-96 overflow-hidden w-0"
          )}
        >
          <div className="   min-h-[95vh] overflow-auto">
            <AnswerListFromAssessee />
          </div>
        </div>
        <div
          className={classNames(
            "sticky  top-0 max-w-sm  right-0  min-h-screen   bg-gray-100 transition-all duration-100  ease-out",
            showGuide
              ? " -translate-x-0 w-full "
              : "translate-x-96 overflow-hidden w-0"
          )}
        >
          <div className="   min-h-[95vh] overflow-auto">
            <GuideAssessor />
          </div>
        </div>
      </div>
      <div className="h-14"></div>
      {isSelfTracksReady && selfTracks && isConnect && (
        <div className="py-2 px-2 fixed bottom-0 w-full bg-black">
          <AssessorControls
            tracks={selfTracks}
            tracksState={isMuteTrackSelf}
            isShareScreen={isShareScreen}
            isOtherShareScreen={
              screenShareAvailable == true && isShareScreen == false
              // true
            }
            errorInfo={errorInfo}
            setJoin={(v) => {
              setJoin(v);
              handleLeaveAlone(!v);
            }}
            setMute={(v) => {
              setMuteSelfTracks(v?.type, v?.status);
            }}
            setShareScreen={() => {
              setSchareScreen(!isShareScreen);
            }}
            channelName={session}
            setShowGuide={() => {
              setShowGuide(!showGuide);
            }}
            setShowListAnswer={() => {
              setShowListAnswer(!showListAnswer);
            }}
            btnAvailable={{
              shareScreen: true,
              guide: true,
              listAnswer: true,
            }}
          />
        </div>
      )}
    </>
  );
}

const VideoMain = (props) => {
  const { userAssessee, shareScreen, usersVolume } = props;
  let videoMain =
    shareScreen?.agora?.agoraDetail != null
      ? shareScreen
      : userAssessee?.agora?.uid != null
      ? userAssessee
      : null;
  console.log("videoMain", videoMain);
  return (
    <>
      {videoMain != null ? (
        <div
          className={classNames(
            false ? "aspect-[9/16]" : "aspect-video",
            "relative h-full p-0  border border-secondary-300 "
          )}
          // className="relative h-full p-0  border border-secondary-300  aspect-video"
          style={{}}
        >
          <VideoPlayer
            videoTrack={videoMain?.agora?.agoraDetail?.videoTrack}
            isVideoMute={!videoMain?.agora?.video}
            isMicMute={!videoMain?.agora?.audio}
            title={videoMain?.name}
            uid={videoMain?.uId}
            tagLable={videoMain?.type == "ASSESSOR" ? videoMain?.type : null}
            shareScreen={shareScreen?.agora?.agoraDetail != null ? true : false}
            isSpeak={checkVoulumeLevel(usersVolume, videoMain?.uId).status}
          />
        </div>
      ) : (
        <div
          className={classNames(
            "bg-black relative  p-1 overflow-hidden border border-secondary-300 aspect-video flex justify-center items-center"
          )}
          style={{ height: "100%" }}
        >
          <p className="text-white ">Waiting Assessee Join</p>
        </div>
      )}
    </>
  );
};

const VideoList = (props) => {
  const { users, tracks, userSelf, usersVolume } = props;
  // Bugs Assessor share screen, tampilan assessee tidak muncul
  return (
    <>
      <div className="flex gap-1 flex-nowrap " style={{ height: "100%" }}>
        {users.find((x) => x.type == "SHARESCREEN")?.agora?.agoraDetail !=
          null && (
          <>
            {users
              ?.filter((x) => x.type == "ASSESSEE" && x.agora != null)
              ?.map((x, i) => {
                return (
                  <VideoPlayer
                    videoTrack={x.agora?.agoraDetail?.videoTrack}
                    isVideoMute={!x.agora?.video}
                    isMicMute={!x.agora?.audio}
                    title={x?.name}
                    uid={x?.uId}
                    tagLable={x?.type == "ASSESSOR" ? x?.type : null}
                    isSpeak={checkVoulumeLevel(usersVolume, x?.uId).status}
                  />
                );
              })}
          </>
        )}
        <VideoPlayer
          videoTrack={tracks[1]}
          isVideoMute={!userSelf.isMuteTrackSelf?.video}
          isMicMute={!userSelf.isMuteTrackSelf?.audio}
          title={userSelf?.name}
          uid={userSelf?.uId}
          tagLable={userSelf?.type == "ASSESSOR" ? userSelf?.type : null}
          isSpeak={checkVoulumeLevel(usersVolume, userSelf?.uId).status}
        />

        {users
          ?.filter((x) => x.type == "ASSESSOR" && x.agora != null)
          ?.map((x, i) => {
            return (
              <VideoPlayer
                videoTrack={x.agora?.agoraDetail?.videoTrack}
                isVideoMute={!x.agora?.video}
                isMicMute={!x.agora?.audio}
                title={x?.name}
                uid={x?.uId}
                tagLable={x?.type == "ASSESSOR" ? x?.type : null}
                isSpeak={checkVoulumeLevel(usersVolume, x?.uId).status}
              />
            );
          })}
      </div>
    </>
  );
};
